import { icons as coreIcons } from '@tango/app/assets/icons';

export const icons: Array<{ name: string; file: string }> = [
  ...coreIcons,
  { name: 'ic-deposit-primary', file: 'ic-deposit-lg-primary.svg' },
  { name: 'pic-deposit-gray', file: 'pic-deposit-lg-gray.svg' },
  { name: 'ic-openinnew-primary', file: 'ic-openinnew-sm-primary.svg' },
  { name: 'ic-info-gray', file: 'ic-info-md-gray.svg' },
  { name: 'icInfo24Primary', file: 'icInfo24Primary.svg' },
  { name: 'ic-globe-md-color', file: 'ic-globe-md-color.svg' },
  { name: 'ic-card-primary', file: 'ic-card-lg-primary.svg' },
  { name: 'ic-drop-arrow-black', file: 'ic-droparrow-md-black.svg' },
  { name: 'ic-copy-primary', file: 'ic-copy-primary.svg' },
];
